function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.47126 17.5424C3.92519 18.1301 3.01786 18.1526 2.44468 17.5927C1.87151 17.0328 1.84953 16.1025 2.3956 15.5148C2.3956 15.5148 10.953 6.44563 10.9778 6.42089C11.5692 5.84131 12.5068 5.86299 13.072 6.46931L21.6027 15.5147C22.1498 16.1014 22.1293 17.0318 21.5571 17.5927C20.9848 18.1536 20.0774 18.1326 19.5304 17.5458L12.2029 9.90828C12.0927 9.79343 11.909 9.7934 11.7988 9.90823L4.47126 17.5424Z",
  fill: "#878793"
});

function SvgIconKeyboardArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-up.9ef49182.svg";
export { ForwardRef as ReactComponent };